import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAddToBasket2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAddToBasket2"><Path d="M17.7488 8.75H20.0599C20.6807 8.75 21.1515 9.30973 21.0451 9.92134L20.7274 11.7485M17.7488 8.75H6.24884M17.7488 8.75L15.7488 3.75M6.24884 8.75H3.93777C3.31697 8.75 2.84619 9.30973 2.95255 9.92134L4.3165 17.764C4.56641 19.201 5.8136 20.25 7.27213 20.25H10.2488M6.24884 8.75L8.24884 3.75M13.7488 18H16.9988M16.9988 18H20.2488M16.9988 18V14.75M16.9988 18V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconAddToBasket2;
